import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-063c6270"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rewards-manager" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加奖励")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small" }, [
  /*#__PURE__*/_createTextVNode(" 奖励按阶梯制生效：玩家实际碰数 ≥ 配置碰数时，取最高匹配档位。 "),
  /*#__PURE__*/_createElementVNode("ul", { class: "mb-0 mt-1" }, [
    /*#__PURE__*/_createElementVNode("li", null, "例：配置了碰数 0、3、6、9 四档"),
    /*#__PURE__*/_createElementVNode("li", null, "玩家碰了 4 对 → 匹配「碰数 3」档（最高 ≤ 4 的门槛）"),
    /*#__PURE__*/_createElementVNode("li", null, "玩家碰了 9 对 → 匹配「碰数 9」档（最高档）"),
    /*#__PURE__*/_createElementVNode("li", null, "不需要每个碰数都配置，只需配关键门槛")
  ])
], -1))
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "配对成功的次数", -1))
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "ms-auto text-muted" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "单位：元", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_3, "已配置 " + _toDisplayString(_ctx.rewards.length) + " 个奖励档位", 1)
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: _ctx.onAddReward
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_alert, {
      title: "奖励规则说明",
      type: "info",
      closable: false,
      class: "mb-3"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_vxe_table, {
      data: _ctx.sortedRewards,
      "row-config": { isHover: true },
      "max-height": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          title: "碰数",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: _ctx.getMatchCountTagType(row.match_count),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.match_count), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "奖励商品图片",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.product?.image)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: row.product.image,
                  "preview-src-list": [row.product.image],
                  fit: "cover",
                  style: {"width":"50px","height":"50px"}
                }, null, 8, ["src", "preview-src-list"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "奖励商品",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.product?.name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "商品回收价",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.product?.recycle_price ? Number(row.product.recycle_price).toFixed(2) + '元' : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "成本价",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(Number(row.cost).toFixed(2)) + "元 ", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              link: "",
              onClick: ($event: any) => (_ctx.onEditReward(row))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              link: "",
              onClick: ($event: any) => (_ctx.onDeleteReward(row))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.isEditingReward ? '编辑奖励' : '添加奖励',
      width: "500px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSaveReward
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "rewardFormRef",
          model: _ctx.rewardForm,
          rules: _ctx.rewardRules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "碰数",
              prop: "match_count"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.rewardForm.match_count,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rewardForm.match_count) = $event)),
                  min: 0,
                  max: 20,
                  disabled: _ctx.isEditingReward
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "奖励商品",
              prop: "product_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.rewardForm.product_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rewardForm.product_id) = $event)),
                  placeholder: "搜索商品",
                  filterable: "",
                  remote: "",
                  "remote-method": _ctx.searchProducts,
                  loading: _ctx.productSearchLoading,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productOptions, (product) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: product.id,
                        label: `${product.name} (回收价: ${Number(product.recycle_price).toFixed(2)}元)`,
                        value: product.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            (product.image)
                              ? (_openBlock(), _createBlock(_component_el_image, {
                                  key: 0,
                                  src: product.image,
                                  fit: "cover",
                                  style: {"width":"30px","height":"30px","margin-right":"8px"}
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(product.name), 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(Number(product.recycle_price).toFixed(2)) + "元", 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "成本价",
              prop: "cost"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.rewardForm.cost,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rewardForm.cost) = $event)),
                  min: 0,
                  max: 9999999
                }, null, 8, ["modelValue"]),
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}